import zigzaga from "./zigzaga";
import laptop from "./laptop";
import phone from "./phone";

const svgs = {
    zigzaga,
    laptop,
    phone
}

export default svgs;